import { render, staticRenderFns } from "./scoreboard_badminton.vue?vue&type=template&id=0f92e206&scoped=true&"
import script from "./scoreboard_badminton.vue?vue&type=script&lang=js&"
export * from "./scoreboard_badminton.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_badminton.vue?vue&type=style&index=0&id=0f92e206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92e206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
